import { jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { validateTidalLicense } from "@workwave-tidal/core/base";
function FormContainer(props) {
  const { children, width = "100%", testId = "form-container-root" } = props;
  return /* @__PURE__ */ jsx(Box, { "data-testid": testId, width, flexDirection: "column", display: "flex", children });
}
validateTidalLicense();
export {
  FormContainer
};
//# sourceMappingURL=FormContainer.js.map
